import { Flex } from "antd";
import { useGetCoursesSummeryQuery } from "../../../../app/features/courses/courses.api";
import useError from "../../../../hooks/useError";
import { enToBnNumber } from "../../../../utils/number.utils";
import EndCourseIcon from "../_icons/EndCourseIcon";
import EnrollIcon from "../_icons/EnrollIcon";
import RunningCourseIcon from "../_icons/RunningCourseIcon";
import TopBarLoading from "./TopBarLoading";

export default function TopBar() {
  const { data, isLoading, error } = useGetCoursesSummeryQuery();
  useError(error, "কোর্স সামারি ডাটা লোড হয়নি");

  const tobBar = [
    {
      id: 1,
      title: "এনরোল্ড কোর্স",
      count: enToBnNumber(data?.enrolled || 0),
      icon: EnrollIcon,
      color: "#F4F5FF",
    },
    {
      id: 2,
      title: "সম্পন্ন কোর্স",
      count: enToBnNumber(data?.completed || 0),
      icon: EndCourseIcon,
      color: "#EDFBF7",
    },
    {
      id: 3,
      title: "চলমান কোর্স",
      count: enToBnNumber(data?.running || 0),
      icon: RunningCourseIcon,
      color: "#FEECEF",
    },
  ];

  return (
    <section className="grid lg:grid-cols-3 md:grid-cols-2 gap-5">
      {isLoading
        ? [...Array(3)].map((_, idx) => <TopBarLoading key={idx} />)
        : tobBar.map((el) => (
            <Flex
              className="p-4 rounded-xl border border-theme-zinc-200"
              gap={16}
              align="center"
              key={el.id}
              title={el.title}
            >
              <Flex
                justify="center"
                align="center"
                className="w-20 h-20 rounded-lg"
                style={{ backgroundColor: el.color }}
              >
                <el.icon />
              </Flex>

              <div className="flex-1">
                <h3 className=" text-theme-zinc-700 text-4xl font-semibold">
                  {el.count}টি
                </h3>
                <p className="text-theme-slate-600 text-lg font-medium">
                  {el.title}
                </p>
              </div>
            </Flex>
          ))}
    </section>
  );
}
